interface GridLayoutProps {
  children: React.ReactNode;
  className?: string;
  gridCols?: string;
  gap?: string;
  padding?: string;
  maxWidth?: string;
}

const GridLayout = ({
  children,
  className = "",
  gridCols = "grid-cols-1 sm:grid-cols-2 lg:grid-cols-3",
  gap = "gap-[2rem] md:gap-[3.2rem]",
  padding = "px-8 sm:px-10 md:px-20 lg:px-[120px]",
  maxWidth = "max-w-[1440px]",
}: GridLayoutProps) => {
  return (
    <div
      className={`grid ${gridCols} ${gap} ${padding} ${maxWidth} mx-auto ${className}`}
    >
      {children}
    </div>
  );
};

export default GridLayout;
